import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { map, of } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';

import { SignInJwtService } from '../dataService/signIn-jwt.service';

@Injectable({
  providedIn: 'root'
})
export class IsSignedInGuard implements CanActivate {
  constructor(
    private router: Router,
    protected signInService: SignInJwtService
  ) {}

  public canActivate(): Observable<boolean> {
    if (this.signInService.isConnecting) {
      return this.signInService.connectedObs.pipe(
        map((connected) => {
          if (!this.signInService.isConnected) {
            this.router.navigate(['login']).catch((error) => {
              console.warn(error);
            });
          }
          return connected;
        })
      );
    } else {
      if (!this.signInService.isConnected) {
        this.router.navigate(['login']).catch((error) => {
          console.warn(error);
        });
      }

      return of(this.signInService.isConnected);
    }
  }
}
